import * as React from 'react';
import { css } from '@emotion/core';
import {injectIntl} from 'react-intl';
import {StatusStep, TimelineSpacer} from './styled';

const statusChronologicalOrder={
  'inProcess': 1,
  'ordered': 2,
  'shipped': 3,
  'completed': 4,
}

const outOfTimelineStatuses={
  'failed': true,
  'returned': true,
  'refunded': true,
  'stopped': true,
  'canceled': true,
}

const OrderTimeline = ({
  singleItem: {status, orderPlacedTime}, intl
}) => {
  if(outOfTimelineStatuses[status]) {
    return null;
  }
  const currentStep = statusChronologicalOrder[status] || -1;
  return (
    <div
      css={css`
          height: 143px;
          margin-top: 30px;
          margin-right: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
      `}
    >
      <StatusStep
        index={0}
        currentStep={currentStep}
        dateTime={orderPlacedTime}
        title={intl.formatMessage({id: "orders.orderPlaced"})}
      />
      <TimelineSpacer width="73px" green={currentStep >= 1} />
      <StatusStep
        index={1}
        currentStep={currentStep}
        title={intl.formatMessage({id: "orders.inProcess"})}
      />
      <TimelineSpacer width="86px" green={currentStep >= 2} />
      <StatusStep
        index={2}
        currentStep={currentStep}
        title={intl.formatMessage({id: "orders.ordered"})}
      />
      <TimelineSpacer width="86px" green={currentStep >= 3} />
      <StatusStep
        index={3}
        currentStep={currentStep}
        title={intl.formatMessage({id: "orders.shipped"})}
      />
      <TimelineSpacer width="73px" green={currentStep >= 4} />
      <StatusStep
        index={4}
        currentStep={currentStep}
        title={intl.formatMessage({id: "orders.completed"})}
      />
    </div>
  );
};

export default injectIntl(OrderTimeline);
